export default {
    title: `Édito`,

    subTitleEN: `Patrick Folléa, directeur de Société Générale Private Banking`,
    subTitleMC: `Nicolas Feit, directeur de Société Générale Private Banking Monaco`,
    subTitleLU: `Olivier Lecler, directeur de Société Générale Private Banking Luxembourg`,
    subTitleCH: `Franck Bonin, directeur de Société Générale Private Banking Suisse`,
    subTitleFR: `Mathieu Vedrenne, directeur de Société Générale Private Banking France`,

    mainContent: `
    <p>
        George Bernard Shaw, célèbre homme de lettres et prix Nobel irlandais, eut un jour ce mot : « Quand l’optimiste invente l’avion, le pessimiste invente le parachute. » Oserais-je dire que notre magazine préfère l’avion… à hydrogène ? <br/>Car c’est bien l’esprit qui l’anime : préférer l’action à l’immobilisme ; choisir l’imagination plutôt que le statu quo ; et donner la parole aux acteurs engagés dans une transformation positive du monde plutôt qu’aux Cassandre.
    </p>
    <p>
        Ce numéro vous montrera ainsi comment la sylviculture s’adapte au changement climatique et comment sont inventés les matériaux de construction du futur ; il vous fera voyager en Angleterre, dans la douce campagne du Kent où la viticulture est en plein essor ; il saluera une belle aventure entrepreneuriale au service de l’imaginaire enfantin ; il mettra en valeur la progression de la place de Paris dans l’art contemporain ; il témoignera enfin de la manière dont la philanthropie apprivoise le temps long pour le mettre au service des autres.
    </p>

    <p>
        Je vous souhaite une excellente lecture de ce magazine.
    </p>`,

};

